import $ from 'jquery';
import _ from 'underscore';
import * as baseWishlistButtonEvents from '../../tracking/wishlist/baseWishlistButtonEvents';
import { getCurrentDataLayer } from '../../../home24-shared/tracking/common/helper';

// initialized in /pages/pdp/pdpBootstrap.js
// as it needs to have access to model

export default function WishlistButtonEvents(options) {
    this.model = options.model;

    _.bindAll(this, 'onAddToWishlist', 'onRemoveFromWishlist');

    $.subscribe('added.wishlist', this.onAddToWishlist);
    $.subscribe('removed.wishlist', this.onRemoveFromWishlist);
}

WishlistButtonEvents.prototype = _.extend({}, baseWishlistButtonEvents, {

    onAddToWishlist: function (event, eventData) {
        var data = this.getTrackingData(eventData.sku);

        this.pushAddToWishlistEvent(data);
    },

    onRemoveFromWishlist: function (event, eventData) {
        var data = this.getTrackingData(eventData.sku);

        this.pushRemoveFromWishlistEvent(data);
    },

    getTrackingData: function (sku) {
        var currentDataLayer = getCurrentDataLayer();

        return {
            sku: sku,
            price: currentDataLayer.productPrice,
            brand: currentDataLayer.productBrand,
            category: getCategoryFromPageTypeEvent(currentDataLayer)
        };
    },

    destroy: function () {
        $.unsubscribe('added.wishlist', this.onAddToWishlist);
        $.unsubscribe('removed.wishlist', this.onRemoveFromWishlist);
    }
});

/**
 * Transforms category information from page type track data into a
 * single string shape to be tracked with wishlist button event.
 *
 * @param {object} pageData - Product page track object
 * @returns {string}
 */
function getCategoryFromPageTypeEvent(pageData) {
    // NOTE: This is for when shop is operating in Navision mode
    if (Array.isArray(pageData.purchasingCategories)) {
        return pageData.purchasingCategories.join('/');
    }

    // NOTE: This is for when shop is operating in SAP mode
    if (pageData.categoryBreadcrumb) {
        return pageData.categoryBreadcrumb;
    }

    return '';
}



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/tracking/pdp-new/pdpWishlistButtonEvents.js
 **/